export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    maxWidth: "400px",
    margin: "0 auto",
    fontFamily: '"Arial", sans-serif',
    overflowX: "hidden",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  input: {
    padding: "10px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "16px",
  },
  button: {
    padding: "10px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#007bff",
    color: "white",
    cursor: "pointer",
    width: "100%",
  },
  secondaryButton: {
    padding: "10px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "1px solid #007bff", // Border color similar to primary button
    backgroundColor: "white", // Secondary color (usually lighter or white)
    color: "#007bff", // Text color similar to primary button background
    cursor: "pointer",
    textDecoration: "none", // In case you use this style on a link that looks like a button
    width: "100%",
  },
  bankAccount: {
    padding: "15px",
    margin: "10px 0",
    borderRadius: "5px",
    border: "1px solid #007bff",
    backgroundColor: "#f8f9fa",
    color: "#007bff",
    cursor: "pointer",
    textAlign: "center",
    textDecoration: "none", // In case you use this style on a link
    boxShadow: "0px 2px 5px rgba(0, 123, 255, 0.2)",
    width: "calc(100% - 30px)",
  },
  checkmark: {
    color: "green",
    fontSize: "50px", // Adjust size as needed
    textAlign: "center",
  },
  header: {
    marginBottom: "20px",
  },
};
